import '@babel/polyfill';
import 'mutationobserver-shim';
import 'what-input';
import Vue from 'vue';
// import './assets/styles/app.scss';
import './plugins/axios';
import './plugins/bootstrap-vue';
import './plugins/vee-validate';
import './plugins/vue-the-mask';
import App from './App.vue';
import router from './router';
import store from './store';
// import './registerServiceWorker';

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
